import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/logo.webp'
import _imports_1 from '../../assets/img/logo-white.webp'
import _imports_2 from '../../assets/img/icons/facebook.svg'
import _imports_3 from '../../assets/img/icons/pinterest.svg'
import _imports_4 from '../../assets/img/icons/instagram.svg'
import _imports_5 from '../../assets/img/icons/twitter.svg'


const _withScopeId = n => (_pushScopeId("data-v-71932f58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "responsive-navbar offcanvas offcanvas-end border-0",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  id: "navbarOffcanvas"
}
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-light",
  src: _imports_0,
  alt: "Image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-dark",
  src: _imports_1,
  alt: "Image"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close-btn bg-transparent lh-1 p-0",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-close-line" })
], -1))
const _hoisted_6 = { class: "offcanvas-body" }
const _hoisted_7 = { class: "responsive-menu mobile-menu" }
const _hoisted_8 = { class: "responsive-menu-list nav-item" }
const _hoisted_9 = { class: "responsive-menu-list nav-item" }
const _hoisted_10 = { class: "responsive-menu-list nav-item" }
const _hoisted_11 = { class: "responsive-menu-list nav-item" }
const _hoisted_12 = { class: "responsive-menu-list nav-item" }
const _hoisted_13 = { class: "responsive-menu-items" }
const _hoisted_14 = { class: "responsive-menu-items" }
const _hoisted_15 = { class: "responsive-menu-items" }
const _hoisted_16 = { class: "responsive-menu-items" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"other-option d-md-flex align-items-center\" data-v-71932f58><ul class=\"social-profile list-style text-md-center\" data-v-71932f58><li data-v-71932f58><a href=\"https://www.fb.com\" target=\"_blank\" data-v-71932f58><img src=\"" + _imports_2 + "\" alt=\"Facebook\" data-v-71932f58></a></li><li data-v-71932f58><a href=\"https://www.pinterest.com\" target=\"_blank\" data-v-71932f58><img src=\"" + _imports_3 + "\" alt=\"Linkedin\" data-v-71932f58></a></li><li data-v-71932f58><a href=\"https://www.instagram.com\" target=\"_blank\" data-v-71932f58><img src=\"" + _imports_4 + "\" alt=\"Instagram\" data-v-71932f58></a></li><li data-v-71932f58><a href=\"https://www.twitter.com\" target=\"_blank\" data-v-71932f58><img src=\"" + _imports_5 + "\" alt=\"Twitter\" data-v-71932f58></a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo d-inline-block"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_router_link, {
            to: "/about-us",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("About Us")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/pricing-plan",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Pricing Plan")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/faq",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("FAQ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_router_link, {
            to: "/contact-us",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact Us")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: _normalizeClass([
            'responsive-menu-list mobile-menu-child',
            { active: _ctx.isActivePages },
          ])
        }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            class: "dropdown-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleActivePages && _ctx.toggleActivePages(...args)))
          }, " Pages "),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", {
              class: _normalizeClass([
                'responsive-menu-list mobile-menu-child',
                { active: _ctx.isActivePortfolio },
              ])
            }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "dropdown-toggle",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleActivePortfolio && _ctx.toggleActivePortfolio(...args)))
              }, " Portfolio "),
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/portfolio" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Portfolio")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/portfolio-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Portfolio Details ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass([
                'responsive-menu-list mobile-menu-child',
                { active: _ctx.isActiveShop },
              ])
            }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "dropdown-toggle",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleActiveShop && _ctx.toggleActiveShop(...args)))
              }, " Shop "),
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/shop-left-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Shop Left Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/shop-right-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Shop Right Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/shop" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Shop Grid")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/product-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Product Details ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/cart" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cart")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/wishlist" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Wishlist")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/checkout" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Checkout")
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass([
                'responsive-menu-list mobile-menu-child',
                { active: _ctx.isActiveBlog },
              ])
            }, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "dropdown-toggle",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleActiveBlog && _ctx.toggleActiveBlog(...args)))
              }, " Blog "),
              _createElementVNode("ul", _hoisted_16, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-left-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Blog Left Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-right-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Blog Right Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Blog Grid")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-details-left-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Blog Details Left Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-details-right-sidebar" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Blog Details Right Sidebar ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/blog-details" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Blog Details No Sidebar ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 2),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/register" }, {
                default: _withCtx(() => [
                  _createTextVNode("Register")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/terms-conditions" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Terms & Conditions ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/privacy-policy" }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy Policy")
                ]),
                _: 1
              })
            ])
          ])
        ], 2)
      ]),
      _hoisted_17
    ])
  ]))
}